import { z } from 'zod'
import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '../../common'

export const AccountSearchParamsSchema = z
  .object({
    q: z.string().optional(),
    accountType: z.string().optional(),
    isActive: z
      .enum(['true', 'false'])
      .transform((v) => v === 'true')
      .optional(),
  })
  .merge(BasePaginateParamsSchema)

export type AccountSearchParams = z.infer<typeof AccountSearchParamsSchema>

export const AccountSearchResultModelSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  accountType: z.string(),
  normalBalance: z.string(),
  parentId: z.number().nullable(),
  allowDirectPosting: z.boolean(),
  isActive: z.boolean(),
})

export type AccountSearchResultModel = z.infer<
  typeof AccountSearchResultModelSchema
>

export const AccountSearchResultSchema = z
  .object({
    data: z.array(AccountSearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type AccountSearchResult = z.infer<typeof AccountSearchResultSchema>

export const AccountSelectOptionModelSchema =
  AccountSearchResultModelSchema.transform((data) => ({
    ...data,
    get label() {
      return `${data.code} ${data.name}`
    },
    get value() {
      return data.id.toString()
    },
  }))

export const AccountSelectOptionResultSchema = z
  .object({
    data: z.array(AccountSelectOptionModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type AccountSelectOptionResult = z.infer<
  typeof AccountSelectOptionResultSchema
>
